import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { ArticleParagraph1 } from '@cian/ui-kit';

import * as React from 'react';

import * as styles from './styles.css';

interface IMenuItemProps {
  icon: React.ReactNode;
  label: string;
  color?: TColors;
  onClick(): void;
}

export const MenuItem: React.FC<IMenuItemProps> = ({ icon, label, color, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <ArticleParagraph1 color={color || 'text-primary-default'}>{label}</ArticleParagraph1>
      <div>{icon}</div>
    </div>
  );
};
